export const application = Object.freeze({
  management: 'management',
  dealer: 'dealer',
  customer: 'customer',
});

const currentApplication = application[process.env.NX_REACT_APP_APP];
const appConfig = {
  application: currentApplication,
  baseApiUrl: process.env.NX_API_BASE_URL + '/api/',
  isDealerApp: currentApplication === application.dealer,
  isManagementApp: currentApplication === application.management,
  isCustomerApp: currentApplication === application.customer,
  showDebugInfo:
    process.env.NX_APP_SHOW_DEBUG_INFO &&
    process.env.NX_APP_SHOW_DEBUG_INFO.toString() === 'true',
};
export { appConfig };
